import { ListFilter } from 'lucide-react';

export interface SectionHeaderRowProps {
  title: string;
  filterActive?: boolean;
}

export function SectionHeaderRow({
  title,
  filterActive = false,
}: SectionHeaderRowProps) {
  return (
    <div className='mk-section'>
      <h3 className='mk-section__title'>{title}</h3>
      <span
        className={`mk-section__filter${filterActive ? ' is-active' : ''}`}
      >
        <ListFilter size={14} strokeWidth={2.2} />
        Filter
      </span>
    </div>
  );
}
